export const slateExecutive = {
  id: 'slate-executive',
  name: 'Slate Executive',
  isDark: false,
  variables: {
    '--font-family-primary': '"Garamond", serif',
    '--font-family-secondary': '"Inter", sans-serif',
    '--color-primary': '#1E293B',      // Slate Dark 800
    '--color-secondary': '#475569',    // Slate Medium 600
    '--color-accent': '#991B1B',       // Deep Crimson
    '--color-bg-page': '#FFFFFF',      // White
    '--color-text-main': '#0F172A',    // Slate Dark 900
    '--color-text-light': '#64748B',   // Slate Muted 500
    '--color-border': '#CBD5E1',       // slate border 300
    '--spacing-multiplier': '1.05',
    '--heading-text-transform': 'none',
    '--heading-letter-spacing': 'normal',
    '--bullet-style': 'disc',
  }
};
